export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-100/70">
      <div className="px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="max-w-[720px] mx-auto text-center">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-6">
            关于51动漫官网
          </h2>
          <p className="text-sm text-foreground-600 leading-relaxed mb-4">
            51动漫官网是一个专注于动漫在线观看与动漫下载的综合性平台，致力于为全球华人动漫爱好者提供优质、便捷的追番体验。
          </p>
          <p className="text-sm text-foreground-600 leading-relaxed mb-4">
            平台自上线以来，始终坚持以用户体验为核心，持续收录日漫、国漫、韩漫等各类动漫全集资源，支持免费在线播放和高速下载。我们独创的下拉式追更模式，让动漫阅读更加流畅自然。
          </p>
          <p className="text-sm text-foreground-600 leading-relaxed mb-4">
            如今，51动漫官网已累计收录超过 20000 部动漫作品，覆盖热血、恋爱、奇幻、搞笑、悬疑等八大动漫类型，每日同步更新最新番剧，真正做到了让漫友随时随地享受追番的乐趣。
          </p>
          <p className="text-sm text-foreground-600 leading-relaxed">
            未来，51动漫官网将持续优化播放体验、丰富内容资源，努力成为您最信赖的动漫在线观看与51动漫下载首选平台。
          </p>
        </div>
      </div>
    </section>
  );
}